export const APP_CONFIG_KEY = 'app';

export type AppConfig = {
    host: string;
};
